// About-page timeline: grows the accent "draw-line" as you scroll and marks each
// milestone the line has reached. The entries come from an ACF repeater, so the
// geometry is measured from the dots themselves — nothing here assumes how many
// there are. No-ops on pages without a .timeline.
const timeline = document.querySelector('.timeline');

if (timeline) {
  const drawLine = timeline.querySelector('.draw-line');
  const defaultLine = timeline.querySelector('.default-line');
  const items = Array.from(timeline.querySelectorAll('li'));

  if (drawLine && defaultLine && items.length) {
    const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    let top = 0;       // where the track starts, relative to .timeline
    let length = 0;    // first dot centre → last dot centre
    let dotCentre = 0; // half the dot's height
    let queued = false;

    // The track runs dot-centre to dot-centre, so it can neither fall short of
    // the first milestone nor overshoot the last, at any entry count. The dot is
    // the li's ::before circle, pinned to the top of the li.
    const measure = () => {
      dotCentre = (parseFloat(getComputedStyle(items[0], '::before').height) || 40) / 2;

      const base = timeline.getBoundingClientRect().top;
      const first = items[0].getBoundingClientRect().top - base + dotCentre;
      const last = items[items.length - 1].getBoundingClientRect().top - base + dotCentre;

      top = first;
      length = Math.max(last - first, 0);

      defaultLine.style.top = `${top}px`;
      defaultLine.style.height = `${length}px`;
      drawLine.style.top = `${top}px`;
    };

    // Fill down to the middle of the viewport, clamped to the track.
    const update = () => {
      queued = false;

      const trackTop = timeline.getBoundingClientRect().top + top;
      const drawn = reduced
        ? length
        : Math.min(Math.max(window.innerHeight / 2 - trackTop, 0), length);

      drawLine.style.height = `${drawn}px`;

      const reachedY = trackTop + drawn;
      items.forEach((item) => {
        const centre = item.getBoundingClientRect().top + dotCentre;
        item.classList.toggle('in-view', centre <= reachedY);
      });
    };

    const onScroll = () => {
      if (queued) return;
      queued = true;
      requestAnimationFrame(update);
    };

    const remeasure = () => {
      measure();
      update();
    };

    measure();
    update();
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', remeasure);
    // Late-loading fonts/images reflow the list and move every dot.
    window.addEventListener('load', remeasure);
  }
}
